module.exports = __webpack_public_path__ + "static/media/012.03d10772.jpg";